<template>
  <div class="flex flex-col w-full bg-white rounded p-4">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>
    
    <div class="flex flex-col w-1/2 mb-2">
      <h4 class="font-semibold text-grey-700">
        {{ $t('frontend_groovemail_contacts_step4_automations') }}
      </h4>
    </div>
    <div class="flex flex-col w-1/2 mb-2">
      <span class="text-sm text-grey-700"
        >
        {{ $t('frontend_groovemail_contacts_step4_configure') }}
        </span
      >
    </div>
    <hr class="border-grey-100 -mx-4" />
    <div class="">
      <div class="flex flex-row mb-2 border-grey-100 border -mx-4 px-4">
        <gd-tabs
          :tabs="automationsSettingsTabs"
          :current-tab="automationsSettingsTab"
          :wrapper-class="'pt-4 px-0 gs-default-tabs'"
          :tab-class="'pb-4 mr-4 gs-default-tabs-item'"
          :tab-active-class="
            'border-primary border-b-2 text-primary gs-default-tabs-item-active'
          "
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleAutomationsSettingsTabChange"
          :key=" this.$t('frontend_groovemail_contact_tabs_step4_tags')"
        />
      </div>
      <div class="mt-4">
        <div v-if="automationsSettingsTab === 'tags'">
          <div class="flex flex-col">
            <div class="w-1/2 flex flex-row">
              <div class="w-1/2 p-3">
                <select
                  class="w-full h-10 outline-none border border-grey-200 rounded-lg px-4"
                  @change="onChangecategory($event)"
                >
                  <option value="" selected>
                    {{ $t('frontend_groovemail_contacts_step4_anycategory') }}
                  </option>
                  <option
                    v-for="category in this.categories"
                    :value="category.id"
                    >{{ category.name }}</option
                  >
                </select>
              </div>
              <div class="w-1/2 p-3" style="height:80px;">
                <select
                  class="w-full h-10 outline-none border border-grey-200 rounded-lg px-4"
                  v-model="localModel.tag"
                  @change="tagChange"
                  v-bind:class="{ disabled: this.tags.length === 0 }"
                >
                  <option selected>Select Tags</option>
                  <option
                    v-for="tag in this.tags"
                    :value="tag.id"
                    :data-name="tag.name"
                    :disabled="
                      localModel.selectedtagids.includes(tag.id) ? true : false
                    "
                    >{{ tag.name }}</option
                  >
                </select>
                <p class="pull-right">
                  {{ $t('frontend_groovemail_contacts_step4_or') }}
                  <a
                    class="ml-2 cursor-pointer text-primary"
                    @click="openCreateMailTag"
                    >
                    {{ $t('frontend_groovemail_contacts_step4_create_newtag') }}
                    </a
                  >
                </p>
              </div>
              <div class="p-3">
                <gd-button
                  class="pull-right"
                  variant="primary"
                  @click="tagaddbtn==false? addtag() : null"
                  >
                  {{ $t('frontend_add') }}
                  </gd-button
                >
              </div>
            </div>
            <div class="w-full flex flex-row">
              <div
                class="flex flex-row rounded-lg text-sm bg-primary text-primary-invert mr-2"
                v-for="tag in this.localModel.selectedtags"
              >
                <div class="p-2">
                  {{ tag.name }}
                </div>
                <div class="p-2 hover:text-red">
                  <div class="cursor-pointer" @click="deletetag(tag)">
                    <i class="fas fa-times"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="automationsSettingsTab === 'lists'">
          <div class="flex flex-col">
            <div class="w-1/2 flex flex-row">
              <div class="w-1/2 p-3">
                <select
                  class="w-full h-10 outline-none border border-grey-200 rounded-lg px-4"
                  @change="listChange($event)"
                  v-model="localModel.list"
                >
                  <option selected>
                    {{ $t('frontend_groovemail_contacts_step4_select_list') }}
                  </option>
                  <option
                    v-for="list in this.lists"
                    :value="list.id"
                    :data-name="list.name"
                    :disabled="
                      localModel.selectedlistids.includes(list.id) ? true : false
                    "
                    :style="{ display: list.id != $route.params.id ? 'block' : 'none' }"
                    >{{ list.name }}</option
                  >
                </select>
                <p class="pull-right">
                  {{ $t('frontend_groovemail_contacts_step4_or') }}
                  <a
                    class="ml-2 cursor-pointer text-primary"
                    @click="openCreateMaillist"
                    >
                    {{ $t('frontend_groovemail_contacts_step4_create_new_list') }}
                    </a
                  >
                </p>
              </div>
              <div class="p-3">
                <gd-button
                  class="pull-right"
                  variant="primary"
                   @click="listaddbtn==false? addlist() : null"
                  >
                  {{ $t('frontend_add') }}
                  </gd-button
                >
              </div>
            </div>
            <div class="w-full flex flex-row">
              <div
                class="flex flex-row rounded-lg text-sm bg-primary text-primary-invert mr-2"
                v-for="list in this.localModel.selectedlists"
              >
                <div class="p-2">
                  {{ list.name }}
                </div>
                <div class="p-2 hover:text-red">
                  <div class="cursor-pointer" @click="deletelist(list)">
                    <i class="fas fa-times"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else></div>
      </div>
    </div>


    <portal to="headerContent">
      <gd-modal name="create-maillist-modal" :title="$t('frontend_groovemail_contacts_step4_create_new_list')">
        <div class="flex flex-col m-10">
          <div class="flex flex-col w-full mb-4">
            <label class="font-semibold text-sm text-grey-700 mb-2">
              {{ $t('frontend_groovemail_contacts_step4_name') }}
            </label>
            <text-input
              variant="base"  
              v-model="localModel.name"
              :placeholder="$t('frontend_name')"
              :validator="$v.localModel.name"
            />
          </div>
          <div class="flex flex-col w-full mb-4">
            <label class="font-semibold text-sm text-grey-700 mb-2"
              >
              {{ $t('frontend_groovemail_contacts_step4_description') }}
              </label
            >
            <text-input
              variant="base"  
              v-model="localModel.description"
              :placeholder="$t('frontend_desc')"
              :validator="$v.localModel.description"
            />
          </div>
          <div class="flex flex-row w-full mb-6 justify-end">
            <gd-button
              variant="primary"
              @click="createMaillist"
              >
              {{ $t('frontend_groovemail_contacts_step4_create_list') }}
              </gd-button
            >
          </div>
        </div>
      </gd-modal>

      <gd-modal name="create-mailtag-modal" :title="$t('frontend_groovemail_contacts_step4_create_newtag')">
        <div class="flex flex-col m-10">
          <div class="flex flex-col w-full mb-4">
            <label class="font-semibold text-sm text-grey-700 mb-2">
              {{ $t('frontend_groovemail_contacts_step4_name') }}
            </label>
            <text-input
              variant="base"  
              v-model="localModel.tgname"
              :placeholder="$t('frontend_name')"
              :validator="$v.localModel.tgname"
            />
          </div>
          <div class="flex flex-col w-full mb-4">
            <label class="font-semibold text-sm text-grey-700 mb-2"
              >
              {{ $t('frontend_groovemail_contacts_step4_description') }}
              </label
            >
            <text-input
              variant="base"  
              v-model="localModel.tgdescription"
              :placeholder="$t('frontend_desc')"
              :validator="$v.localModel.tgdescription"
            />
          </div>

          <div class="flex flex-col w-full mb-4">
            <label class="font-semibold text-sm text-grey-700 mb-2"
              >
              {{ $t('frontend_groovemail_contacts_step4_category') }}
              </label
            >

            <multiselect
              v-model="localModel.tgcategory"
              :options="this.categories"
              :multiple="true"
              track-by="id"
              :hide-selected="true"
              :close-on-select="false"
              :custom-label="customLabel"
              :searchable="true"
              placeholder=""
              :show-labels="false"
              @select="toggleSelected"
            >
            </multiselect>
            <p class="pull-right">
              {{ $t('frontend_groovemail_contacts_step4_or') }}
              <a
                class="ml-2 cursor-pointer text-primary"
                @click="opencreatecategory"
                >
                {{ $t('frontend_groovemail_contacts_step4_create_new_category') }}
                </a
              >
            </p>
          </div>

          <div class="flex-col mb-4 w-full"  v-bind:style="{ display: this.newcategorybox }">
            <label class="font-semibold text-sm text-grey-700 mb-2"
              >
              {{ $t('frontend_groovemail_contacts_step4_create_new_category_name') }}
              </label
            >
            <div class="w-5/6 flex float-left">
              <text-input
                variant="base"  
                v-model="localModel.categoryname"
                :placeholder="$t('frontend_groovemail_tags_category_name')"
                :validator="$v.localModel.categoryname"
              />
            </div>
            <div class="w-1/12 flex pull-right"><gd-button variant="primary" size="icon" @click="savecategory">+</gd-button></div>
          </div>

          <div class="flex flex-row w-full mb-6 justify-end">
            <gd-button
              variant="primary"
              @click="createMailTag"
              >
              {{ $t('frontend_groovemail_contacts_step4_create_tag') }}
              </gd-button
            >
          </div>
        </div>
      </gd-modal>

    </portal>

  </div>
</template>
<script>

import TagLead from '@/models/TagLead';
import ListLead from '@/models/ListLead';
import Maillist from '@/models/Maillist';
import Maillead from '@/models/Maillead';
import Contact from '@/models/Contact';
import Import from '@/models/Import';
import Category from '@/models/Category';
import Mailtag from '@/models/Mailtag';
import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';
import showAlert from '@/components/sweet-alert-popup.js';

const axios = require('axios');
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
export default {
  name: 'step4',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
      tags:[],
      lists:[],
      categories:[],
      tagcategory:[],
      tagaddbtn:true,
      listaddbtn:true,
      newcategorybox:'none',
      selectedcategory: null,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      automationsSettingsTabs: [
        {
          title: this.$t('frontend_groovemail_contact_tabs_step4_tags'),
          value: 'tags'
        },
        {
          title: this.$t('frontend_groovemail_contact_tabs_step4_additional'),
          value: 'lists'
        }
      ],
      automationsSettingsTab: 'tags',

    };
  },
  validations: {
    localModel: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20)
      },
      description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40)
      },
      tgname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20)
      },
      tgdescription: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40)
      },
      categoryname:{
        required,
        minLength: minLength(3),
        maxLength: maxLength(40)
      }
    }
  },
  methods: {
    validate() {
      //this.$v.$touch();
      //var isValid = !this.$v.$invalid;
      var isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },

    handleAutomationsSettingsTabChange(newTab) {
      this.automationsSettingsTab = newTab;
    },

    addtag: function(e) {
      if (this.localModel.tag != '' && this.localModel.tagname != '') {
        this.localModel.selectedtags.push({
          id: this.localModel.tag,
          name: this.localModel.tagname
        });
        this.localModel.selectedtagids.push(this.localModel.tag);
        this.localModel.tag = '';
        this.localModel.tagname = '';
      }
    },

    addlist: function(e) {
      if (this.localModel.list != '' && this.localModel.listname != '') {
        this.localModel.selectedlists.push({
          id: this.localModel.list,
          name: this.localModel.listname
        });
        this.localModel.selectedlistids.push(this.localModel.list);
        this.localModel.list = '';
        this.localModel.listname = '';
      }
    },

    customLabel(option) {
      return `${option.name}`;
    },

    toggleSelected(value, id) {
      console.log(value.id);
    },

    opencreatecategory(){
      this.newcategorybox = 'block';
    },

    async onChangecategory(e) {
      const { data } = await axios.get('/mailtag', {
        params: { category: e.target.value }
      });
      if (data.length > 0) {
        this.tags = data;
        this.hastag = false;
      } else {
        this.hastag = true;
      }
      console.log(this.tags.length);
    },

    async savecategory(){
      this.$v.localModel.categoryname.$touch();
      if (
        !this.$v.localModel.categoryname.$invalid
      ) {
        this.showLoader();
        this.category = new Category({});
        this.category.name = this.localModel.categoryname;
        await this.category.save().then(response => {
          this.fetchEventsCategory();
          this.localModel.categoryname = '';
          this.newcategorybox = 'none';
        }).catch(e => {
          this.showErrorModal(e.response.data.error);
        });
        this.hideLoader();
      }
    },

    showErrorModal: function(error){
      showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark">`+ error +`</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t(
          'frontend_close'
        ),
      });
    },

    async fetchEventsCategory() {
      this.categories = await Category.$get();
    },

    tagChange: function(e) {
      if (e.target.options.selectedIndex > -1) {
        this.localModel.tagname =
          e.target.options[e.target.options.selectedIndex].dataset.name;
        this.tagaddbtn = false;
      }
    },

    listChange: function(e) {
      if (e.target.options.selectedIndex > -1) {
        this.localModel.listname =
          e.target.options[e.target.options.selectedIndex].dataset.name;
      }
      this.listaddbtn = false;
    },

    deletetag: function(tag) {
      var index = this.localModel.selectedtags.indexOf(tag);
      if (index > -1) {
        this.localModel.selectedtags.splice(index, 1);
        this.localModel.selectedtagids.splice(index, 1);
      }
    },

    deletelist: function(list) {
      var index = this.localModel.selectedlists.indexOf(list);
      if (index > -1) {
        this.localModel.selectedlists.splice(index, 1);
        this.localModel.selectedlistids.splice(index, 1);
      }
    },

    openCreateMailTag() {
      this.localModel.tgname = '';
      this.localModel.tgdescription = '';
      this.localModel.tgcategory = '';
      this.$root.$emit('modal-open', 'create-mailtag-modal');
    },

    openCreateMaillist() {
      this.localModel.name = '';
      this.localModel.description = '';
      this.$root.$emit('modal-open', 'create-maillist-modal');
    },

    async createMaillist() {
      this.$v.localModel.name.$touch();
      this.$v.localModel.description.$touch();

      if (
        !this.$v.localModel.name.$invalid &&
        !this.$v.localModel.description.$invalid
      ) {
        this.showLoader();
        this.mail_list = new Maillist({});
        this.mail_list.name = this.localModel.name;
        this.mail_list.description = this.localModel.description;
        await this.mail_list.save().then(response => {
          this.fetchEventsList();
          this.hideLoader();
          this.$root.$emit('modal-close', 'create-maillist-modal');
        }).catch(e => {
          this.showErrorModal(e.response.data.error);
        });

      }
    },

    async fetchEventsList() {
      this.lists = await Maillist.$get();
    },

    async createMailTag() {
      this.$v.localModel.tgname.$touch();
      this.$v.localModel.tgdescription.$touch();

      if (
        !this.$v.localModel.tgname.$invalid &&
        !this.$v.localModel.tgdescription.$invalid
      ) {
        this.showLoader();
        this.mailtag = new Mailtag({});
        this.mailtag.name = this.localModel.tgname;
        this.mailtag.description = this.localModel.tgdescription;
        this.mailtag.categories = this.localModel.tgcategory;
        await this.mailtag.save().then(response => {
          this.fetchEventsTag();
        }).catch(e => {
          this.showErrorModal(e.response.data.error);
        });
        this.hideLoader();

        this.$root.$emit('modal-close', 'create-mailtag-modal');
      }
    },

    async fetchEventsTag() {
      var self = this;
      //self.$wait.start('mailtag');
      const { data } = await axios.get('/mailtag', {
        params: { category: self.selectedcategory }
      });
      if (data.length > 0) {
        self.tags = data;
        self.hastag = false;
      } else {
        self.hastag = true;
      }

      //self.$wait.end('mailtag');
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    }

  },
  async created() {
    this.categories = await Category.$get();
    this.lists = await Maillist.$get();
    console.log(this.localModel.selectedtags);
    console.log(this.localModel.selectedlists);
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  }
};
</script>

